import { createContext, useEffect, useReducer, useState } from "react";
import { initialState, cartReducer } from "../../../store/cartReducer";
import {
  deleteProductFromCartService,
  getCartItemsService,
  postAddProductToCartService,
  postUpdateProductQtyCartService, 
} from "../../../api/apiServices";
import { actionTypes } from "../../../utils/actionTypes";
import { useAuthContext, useProductsContext } from "..";
import { notify } from "../../../utils/utils";
import commonObj from '../../../utils/Common';

export const CartContext = createContext(); 

const CartContextProvider = ({ children }) => {
  const { token, userInfo } = useAuthContext();
  const { updateInCartOrInWish, clearCarted } = useProductsContext();
  const [loadingCart, setLoadingCart] = useState(false);
  const [disableCart, setDisableCart] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState('');

  const [state, dispatch] = useReducer(cartReducer, initialState);

  useEffect(() => {
    if (token) {
      setLoadingCart(true);
      (async () => {
        try {
          let cartRes;
          cartRes = JSON.parse(localStorage.getItem("cartData"))
          if(cartRes==null) cartRes = []
            dispatch({
              type: actionTypes.INITIALIZE_CART,
              payload: cartRes,
            });
        } catch (err) {
          console.log(err);
          notify(
            "error",
            err?.response?.data?.errors
              ? err?.response?.data?.errors[0]
              : err?.response?.data?.message
          );
        } finally {
          setLoadingCart(false);
        }
      })();
    }
  }, [token]);

  const addProductToCart = async (product, imgurl, proposedPrice, id) => {
    setDisableCart(true);

    if(userInfo?.userType===5){ 
      notify("info", commonObj.getLabel('Seller_Account_Missing'));
      return true;
    }

    try {
     
        localStorage.setItem( "cartData",JSON.stringify([{ ...product, proposedPrice:proposedPrice, randomKey:btoa('sqwa--!'+id+'wxxzs!!')}, ...state.cart]) );
        localStorage.setItem( "imgurl",JSON.stringify(imgurl) );

        dispatch({
          type: actionTypes.ADD_PRODUCT_TO_CART,
          payload: [{ ...product, proposedPrice:proposedPrice, randomKey:btoa('sqwa--!'+id+'wxxzs!!')}, ...state.cart],
        });
        //updateInCartOrInWish(product.id, "inCart", true);
        notify("success", commonObj.getLabel('Product_Added_Bag'));

      console.log({ product });
    } catch (err) {
      console.log(err);
      notify(
        "error",
        err?.response?.data?.errors
          ? err?.response?.data?.errors[0]
          : commonObj.getLabel('Some_Error_Occurred')
      );
    } finally {
      setDisableCart(false);
    }
  };

  
  const deleteProductFromCart = async (productId) => {
    setDisableCart(true);

    let cartRes;
    cartRes = JSON.parse(localStorage.getItem("cartData"))
    if(cartRes==null) cartRes = []

    cartRes = cartRes.filter((product, index) => product.id !== productId);
    localStorage.setItem( "cartData",JSON.stringify(cartRes) );

    console.log(cartRes)
    try {
        dispatch({
          type: actionTypes.DELETE_PRODUCTS_FROM_CART,
          payload: cartRes,
        });
        //updateInCartOrInWish(productId, "inCart", false);
        notify("info", commonObj.getLabel('Product_Removed_from_Bag'));
    } catch (err) {
      console.log(err);
      notify(
        "error",
        err?.response?.data?.errors
          ? err?.response?.data?.errors[0]
          : commonObj.getLabel('Some_Error_Occurred')
      );
    } finally {
      setDisableCart(false);
    }
  };

  const clearCart = () => {
    localStorage.removeItem("cartData");
    state.cart.map(async ({ id }) => {
      try {
       
        dispatch({
          type: actionTypes.DELETE_PRODUCTS_FROM_CART,
          payload: [],
        });
      } catch (err) {
        console.log(err);
        notify(
          "error",
          err?.response?.data?.errors
            ? err?.response?.data?.errors[0]
            : commonObj.getLabel('Some_Error_Occurred')
        );
      }
    });
    //updateInCartOrInWish();
  };

  const updateProductQtyInCart = async (productId, type) => {
    setDisableCart(true);
    try {
      const response = await postUpdateProductQtyCartService(
        productId,
        type,
        token
      );
      console.log({ response });
      if (response.status === 200 || response.status === 201) {
        if (type === "increment") {
          dispatch({
            type: actionTypes.UPDATE_PRODUCT_QTY_IN_CART,
            payload: state.cart.map((product) =>
              product.id === productId
                ? { ...product, qty: product.qty + 1 }
                : product
            ),
          });
        } else {
          dispatch({
            type: actionTypes.UPDATE_PRODUCT_QTY_IN_CART,
            payload: state.cart.map((product) =>
              product.id === productId
                ? { ...product, qty: product.qty - 1 }
                : product
            ),
          });
        }
      }
    } catch (err) {
      console.log(err);

      notify(
        "error",
        err?.response?.data?.errors
          ? err?.response?.data?.errors[0]
          : commonObj.getLabel('Some_Error_Occurred')
      );
    } finally {
      setDisableCart(false);
    }
  };

  const { totalPriceOfCartProducts, actualPriceOfCart, adminFee } = state.cart.reduce(
    (acc, { productQuantity, productPrice, proposedPrice }) => {
      console.log(acc, 'acc value');
      
      const feePernt = (acc.productrefType === 4 || acc.productrefType === 5) ? 11 : 10;
      const newActualPrice = acc.actualPriceOfCart + productQuantity * proposedPrice;
      
      return {
        totalPriceOfCartProducts: acc.totalPriceOfCartProducts + productQuantity * proposedPrice,
        actualPriceOfCart: newActualPrice,
        adminFee: (((newActualPrice) * feePernt) / 100).toFixed(2)
      };
    },
    { totalPriceOfCartProducts: 0, actualPriceOfCart: 0, adminFee: 0 }
  );

  const imgurl = (localStorage.getItem("imgurl")!=='') ? JSON.parse(localStorage.getItem("imgurl")) : '';

  return (
    <CartContext.Provider
      value={{
        cart: state.cart,
        disableCart,
        loadingCart,
        addProductToCart,
        updateProductQtyInCart,
        deleteProductFromCart,
        totalPriceOfCartProducts,
        actualPriceOfCart,
        clearCart,
        imgurl,
        adminFee,
        deliveryDate,
        setDeliveryDate,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
